import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { checkError } from "../../utils/utils";
import { fetchLogin } from "../../redux/actions/loginAction";
import { fetchToken } from "../../redux/actions/tokenAction";
import { useAppDispatch } from "../../redux/hook";

import phone from "../../assets/images/icons/call-center-support-service.svg";
import mail from "../../assets/images/icons/mail-send-envelope.svg";
import location from "../../assets/images/icons/location-pin-3.svg";
import contactImage from "../../assets/images/contact.svg";

import Navlight from "../../components/navlight";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";

import { FiHexagon } from "../../assets/icons/vander";

export default function Login() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");

  const handleToken = async (event) => {
    event.preventDefault();

    try {
      const tokenData = {
        email: email,
        password: password,
      };

      const token = await dispatch(fetchToken(tokenData));

      sessionStorage.setItem("token", token.payload);

      setToken(token.payload);
    } catch (error) {
      console.log(error);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleLogin = async () => {
    try {
      const loginData = {
        email: email,
        authorization: token,
      };

      const login = await dispatch(fetchLogin(loginData));

      if (login.payload === "ERR_BAD_REQUEST") {
        navigate(checkError(login));
      } else {
        navigate("/dashboard", { replace: true });
      }
    } catch (error) {
      alert(error.response?.data?.message || "Error occurred");
    }
  };

  useEffect(() => {
    if (token) handleLogin();
  }, [handleLogin, token]);

  return (
    <div className="external">
      <Navlight />
      <section className="relative table w-full py-32 lg:py-40 bg-[url('../../assets/images/portfolio/bg-login-inner.jpg')] bg-no-repeat bg-top bg-cover">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black"></div>
        <div className="container relative">
          <div className="grid grid-cols-1 pb-8 text-center mt-10">
            <h3 className="text-3xl leading-normal font-medium text-white">
              {t("external.login.login")}
            </h3>
          </div>
        </div>

        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="tracking-[0.5px] mb-0 inline-block">
            <li
              className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white"
              aria-current="page"
            >
              {t("external.login.login")}
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            className="w-full h-auto scale-[2.0] origin-top"
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="relative md:pb-24 pb-16">
        <div className="container relative md:mt-24 mt-16">
          <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
            <img src={contactImage} alt="" />

            <div className="lg:ms-5">
              <div className="bg-white dark:bg-slate-900 rounded-xl shadow dark:shadow-gray-700 p-6">
                <h3 className="mb-6 text-2xl leading-normal font-medium">
                  {t("external.login.area_of_login")}
                </h3>

                <form id="form" onSubmit={handleToken}>
                  <div className="grid lg:grid-cols-12 lg:gap-6">
                    <div className="lg:col-span-6 mb-5">
                      <label htmlFor="name" className="form-label font-medium">
                        {t("external.login.user")}
                      </label>
                      <input
                        name="email"
                        id="email"
                        type="text"
                        className="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2"
                        placeholder="Name :"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="lg:col-span-6 mb-5">
                      <label htmlFor="email" className="form-label font-medium">
                        {t("external.login.password")}
                      </label>
                      <input
                        name="password"
                        id="password"
                        type="password"
                        className="form-input w-full py-2 px-3 h-10 bg-transparent border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded-xl outline-none focus:border-orange-500/50 dark:focus:border-orange-500/50 focus:ring-0 mt-2"
                        placeholder="Email :"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    id="submit"
                    name="send"
                    className="py-2 px-5 inline-block font-normal tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white rounded-xl"
                  >
                    {t("external.login.enter")}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="container relative lg:mt-24 mt-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px]">
            <div className="text-center px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28 fill-orange-500/5 mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  <img src={phone} className="h-8" alt="" />
                </div>
              </div>
              <div className="content mt-7">
                <h5 className="title text-lg font-medium">
                  {t("external.login.phone")}
                </h5>
                <div className="mt-5">
                  <Link
                    to="tel:+553199526501"
                    className="text-orange-500 hover:text-orange-500 after:bg-orange-500 transition duration-500"
                  >
                    (31) 2552-2078 / (31) 9 9952-6501
                  </Link>
                </div>
              </div>
            </div>
            <div className="text-center px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28 fill-orange-500/5 mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  <img src={mail} className="h-8" alt="" />
                </div>
              </div>

              <div className="content mt-7">
                <h5 className="title text-lg font-medium">
                  {t("external.login.email")}
                </h5>
                <div className="mt-5">
                  <Link
                    to="mailto:contact@example.com"
                    className="text-orange-500 hover:text-orange-500 after:bg-orange-500 transition duration-500"
                  >
                    amcatdassociaçãoparatodos@gmail.com
                  </Link>
                </div>
              </div>
            </div>

            <div className="text-center px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28 fill-orange-500/5 mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  <img src={location} className="h-8" alt="" />
                </div>
              </div>
              <div className="content mt-7">
                <h5 className="title text-lg font-medium">
                  {t("external.login.location")}
                </h5>
                <p className="text-slate-400 dark:text-white/60 mt-3">
                  Rua Antônio Teixeira Dias, 1600 - Teixeira Dias - Belo
                  Horizonte - MG
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container-fluid relative">
        <div className="grid grid-cols-1">
          <div className="w-full leading-[0] border-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin"
              style={{ border: "0" }}
              title="my-frame"
              className="w-full h-[500px]"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
      <Footer />
      <Switcher />
    </div>
  );
}
